import React, { useContext } from 'react'
import ReactDOM from 'react-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ContentInner } from '../../layout/Content'
import ModalWindow from '../../layout/modalwindow/ModalWindow'
import StockInListInnerStyle from './css/StockInListInnerStyle'
import StockInItemController from '../stockinitem/StockInItemController'
import { stockInListControllerContext } from '../stockinlist/StockInListController'
import { appContext } from '../../../App'

function StockInListInner() {
  const app = useContext(appContext)
  const setContent = app.content[1]
  const stockInListController = useContext(stockInListControllerContext)
  const [selectAll, setSelectAll] = stockInListController.selectAll
  const { stockInList, sortStockInListBy, addSelectedSIId, removeSelectedSIId,
    stockInListSorted, foundUnpostedSI, getStockInByID, reloadStockInList } = stockInListController
  const startSlice = stockInListController.startSlice[0]
  const endSlice = stockInListController.endSlice[0]
  const [sortBy, setSortBy] = stockInListController.sortBy

  const onClickListItem = async (e) => {
    if (e.target.type === 'checkbox') return
    // Get the current item ID
    const si_id= e.target.closest('.si-item').id
    const stockInItem = await getStockInByID(app, si_id) // Fetch the updated data from the database directly

    const showMessageBox = () => {
      const onClick = async () => {
        await reloadStockInList()
        ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
      }
      ReactDOM.render (
        <ModalWindow id='mw-parent' height='20' width='25' header='SI Not Found' footer={null}>
          <div className='messagebox'>
            <div className='messagebox-content'>
              <div>The StockIn file/record no longer exist.</div>
            </div>
            <div className='button-container'>
              <button onClick={onClick} className='pospro-action-btn top-anchor'>Ok</button>
            </div>
          </div>
        </ModalWindow>,
        document.getElementById('modal-form-container')
      )
    }

    // Check first if the si still exist
    if (stockInItem) setContent(<StockInItemController stockInItem={stockInItem}/>)
    else { showMessageBox() }
  }

  const onClickSort = (e) => {
    const header = e.target.closest('.title-header')
    sortStockInListBy(header.id)
    setSortBy(header.id)
  }

  const onClickSelectAll = (e) =>  { setSelectAll(!selectAll) }

  const onClickCheckBox = (e) => {
    const si_id = e.target.closest('.si-item').id
    const checked = e.target.checked
    if (checked) addSelectedSIId(si_id)
    else removeSelectedSIId(si_id)
  }

  let userHaveFC = true
  if (app.client.signed_in !== 'admin') userHaveFC = app.client.signed_in.user_access.stockin_fc

  return (
    <ContentInner>
      <div className='table-stock-in-container'>
        <table className="table striped-table">
          <thead>
            <tr>
              <th>
                <div
                  id='date_received'
                  onClick={onClickSort}
                  className='title-header'>
                  <div>Date Received</div>
                  <span>
                    {
                      (sortBy === 'date_received') ?
                        (stockInListSorted) ?
                          <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-up'/>
                          : <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-down-alt'/>
                        : ''
                    }
                  </span>
                </div>
              </th>
              <th>
                <div
                  id='destination_warehouse'
                  onClick={onClickSort}
                  className='title-header'>
                  <div>Destination Warehouse</div>
                  <span>
                    {
                      (sortBy === 'destination_warehouse') ?
                        (stockInListSorted) ?
                          <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-up'/>
                          : <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-down-alt'/>
                        : ''
                    }
                  </span>
                </div>
              </th>
              <th>
                <div
                  id='received_by'
                  onClick={onClickSort}
                  className='title-header'>
                  <div>Received By</div>
                  <span>
                    {
                      (sortBy === 'received_by') ?
                        (stockInListSorted) ?
                          <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-up'/>
                          : <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-down-alt'/>
                        : ''
                    }
                  </span>
                </div>
              </th>
              <th>
                <div
                  id='reference_code'
                  onClick={onClickSort}
                  className='title-header'>
                  <div>Reference</div>
                  <span>
                    {
                      (sortBy === 'reference_code') ?
                        (stockInListSorted) ?
                          <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-up'/>
                          : <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-down-alt'/>
                        : ''
                    }
                  </span>
                </div>
              </th>
              <th>
                <div
                  id='supplier_name'
                  onClick={onClickSort}
                  className='title-header'>
                  <div>Supplier</div>
                  <span>
                    {
                      (sortBy === 'supplier_name') ?
                        (stockInListSorted) ?
                          <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-up'/>
                          : <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-down-alt'/>
                        : ''
                    }
                  </span>
                </div>
              </th>
              <th>
                <div
                  id='status'
                  onClick={onClickSort}
                  className='title-header'>
                  <div>Status</div>
                  <span>
                    {
                      (sortBy === 'status') ?
                        (stockInListSorted) ?
                          <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-up'/>
                          : <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-down-alt'/>
                        : ''
                    }
                  </span>
                </div>
              </th>
            {
              (userHaveFC)
              ? <th className='empty-header' style={{ display: (foundUnpostedSI) ? 'flex' : 'none', paddingTop: '18px' } }>
                  <button
                    type="button"
                    className='pospro-action-btn toolbar-btn'
                    id="select-all-btn"
                    title="Select/Unselect all selectable items on the list"
                    onClick={onClickSelectAll}>
                    {
                      (selectAll) ? (<span style={{fontSize: '1rem' }}><FontAwesomeIcon icon='check-square'/></span>)
                      : (<span style={{fontSize: '1rem'}}><FontAwesomeIcon icon='square'/></span>)
                    }
                  </button>
                </th>
              : null
            }
            </tr>
          </thead>
          {
            stockInList.slice(startSlice, endSlice).map((stockIn, index) => (
              <tbody key={stockIn._id} id={index}>
                <tr className='si-item' id={stockIn._id} onClick={onClickListItem}>
                  <td>{new Date(stockIn.date_received).toLocaleString("en-us", { timeZone: stockIn.client_timezone }).split(",")[0]} { stockIn.client_timezone }</td>
                  <td>{stockIn.warehouse.name}</td>
                  <td>{stockIn.received_by}</td>
                  <td>{stockIn.reference_code.toUpperCase()}</td>
                  <td>{stockIn.supplier_name}</td>
                  <td><span className={`status ${stockIn.status.toLowerCase()}`}>{stockIn.status}</span></td>
                  {
                    (foundUnpostedSI && userHaveFC)
                    ? <td>{
                        (stockIn.status === 'Unposted')
                        ? <input type='checkbox' onClick={onClickCheckBox} className='si-checkbox'/>
                        : ''
                      }</td>
                    : null
                  }
                </tr>
              </tbody>
            ))
          }
        </table>
      </div>
      <StockInListInnerStyle />
    </ContentInner>
  )
}

export default React.memo(StockInListInner)